import useProfileQuery from '../../queries/use-profile-query'
import Layout from '../../layout/layout'
import '../../assets/css/amember.css'
import PricingForm from '../../components/pricingForm'

const PricingNewPage = () => {
  const { token: isLoggedIn } = useProfileQuery()

  return (
    <Layout>
      <main className="flex flex-col items-center w-full h-full mt-6">
        <div className="md:flex md:mb-10 hidden justify-center items-center w-full h-16 rounded-2xl bg-white bg-opacity-20 backdrop-filter-[40] backdrop-blur-sm">
          <p className="font-poppinsBold text-2xl text-white">Pricing Plan</p>
        </div>
        <PricingForm isLoggedIn={!!isLoggedIn} />

        <footer className="footer">
          <div className="footer__info">
            <div className="footer__links">
              <a
                className="footer__link"
                href="/terms-and-conditions"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms & Conditions
              </a>
              <a
                className="footer__link"
                href="/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              <a
                className="footer__link"
                href="/crm/aff/aff"
                target="_blank"
                rel="noopener noreferrer"
              >
                Affiliates
              </a>
            </div>
            <p className="footer__copyright">COPYRIGHT © 2019-2025 - TAZZ TV</p>
          </div>
          <div className="footer__trust">
            <img
              className="footer__trust-logo"
              src="/icons/amember/trustpilot.png"
              alt="Trustpilot Logo"
              height="32"
              width="128"
            />
            <span className="footer__trust-text">4.6 out of 5 based on 4389 Reviews</span>
          </div>
        </footer>
      </main>
    </Layout>
  )
}

export default PricingNewPage
